import Phaser from 'phaser';
import $ from 'jquery';
import config from '../helpers/config.js';
import { CST } from '../CST';

var loadWheel;
export var language = '';

export default class Preload extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.PRELOAD);
	}

	preload() {
		this.anims.create({
			key: 'load',
			frames: this.anims.generateFrameNames('loading'),
			frameRate: 8,
			repeat: -1,
		});
		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'loading_bg');
		loadWheel = this.add.sprite(
			this.cameras.main.width / 2 - 525,
			this.cameras.main.height / 2 + 200,
		);
		loadWheel.play('load');

		const overlay = document.getElementById('loading-overlay');
		if (overlay) overlay.classList.add('hidden');

		this.load.audio('clickSound', 'assets/Sounds/Click/3. 448080__breviceps__wet-click.mp3');
		this.load.plugin(
			'rexinputtextplugin',
			'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexinputtextplugin.min.js',
			!0,
		);

		this.load.on('complete', async () => {
			let self = this;

			const urlParams = new URLSearchParams(window.location.search);
			const isView = urlParams.get('view');

			if (isView) {
				config.isViewOnly = true;
				this.scene.start(CST.SCENES.BOARDONLYVIEW);
			} else {
				config.isViewOnly = false;
				if (config.online) {
					$.ajax({
						async: false,
						type: 'get',
						url: 'website/authorization.php',
						headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` },
						dataType: 'JSON',
						success(response) {
							if (response[0] === 400) {
								self.scene.start(CST.SCENES.LOGIN);
							} else {
								!response[2]
									? self.scene.start(CST.SCENES.LICENSEEXPIRED, { isOrg: response[3] })
									: self.scene.start(CST.SCENES.MENU);
							}
						},
						error(error) {
							console.log(error);
						},
					}).responseJSON;
				} else {
					this.scene.start(CST.SCENES.MENU);
				}
			}
		});
	}

	create() {}

	upload() {}
}
